import React from 'react';
import { Link, graphql } from 'gatsby';
import BackgroundImage from 'gatsby-background-image';
import GatsbyImage from 'gatsby-image';
import moment from 'moment';
import { getBlogUrl } from '@lib/urls';

function PostCard ({ parent, post, language }) {
  let postLink = getBlogUrl({ parent, page: post, language });
  return (
    <div className="d-flex col-xl-4 col-md-6 col-sm-12">
      <div className="card w-100 border-0 shadow">
        <Link to={postLink}>
          <BackgroundImage
            alt="Image"
            className="card-img-top"
            style={{ height: '200px' }}
            fluid={post.acf.featured_image.localFile.sharp.fluid}
          />
        </Link>
        <div className="card-body d-flex flex-column">
          <div className="d-flex justify-content-between mb-3">
            <div className="text-small d-flex">
              <div className="badge bg-primary-alt text-primary">
                <Link to={postLink}>{post.categories && post.categories[0].name}</Link>
              </div>
            </div>
            <div className="text-small d-flex">
              <span className="text-muted">{post.acf.publish_date}</span>
            </div>
          </div>
          <Link to={postLink}>
            <h4>{post.acf.title}</h4>
          </Link>
          <p className="flex-grow-1">
            {post.acf.excerpt}
          </p>
          <div className="d-flex align-items-center mt-3">
            {post.author.acf.photo && (
              <GatsbyImage
                alt="Image"
                className="avatar avatar-sm shadow"
                fluid={post.author.acf.photo.localFile.sharp.fluid}
              />
            )}
            <div className="ml-1">
              <span className="text-small"> {post.author.acf.name}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function BlogPosts({ parent, posts, authors, language }) {
  const blogPosts = posts.nodes.map(post =>
    Object.assign({}, post, {
      author: authors.nodes.find(({ wordpress_id }) =>
        wordpress_id === post.acf.author
      )
    })
  ).sort((a, b) =>
    moment(b.acf.publish_date, 'DD/MM/YYYY').toDate().getTime() - moment(a.acf.publish_date, 'DD/MM/YYYY').toDate().getTime()
  );
  console.log(blogPosts);
  return (
    <div className="bg-primary pt-5 pb-5">
      <div className="container">
        <div className="row align-items-stretch">
          {blogPosts.map((post, i) => (
            <PostCard key={`post-${i}`} post={post} language={language} parent={parent} />
          ))}
        </div>
      </div>
    </div>
  );
}

export const query = graphql`
  fragment BlogPosts on wordpress__wp_blogposts {
    categories {
      name
      slug
    }
    acf {
      author
      body
      publish_date
      slug
      excerpt
      title
      featured_image {
        localFile {
          sharp: childImageSharp {
            fluid(maxWidth: 500) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`;